export default __webpack_public_path__ + "locales/sr-Cyrl-RS/UploadPanel.json?hash=89d924464d59c5db57d8073541745538";